import React, { Fragment } from "react";
import { observer, inject } from "mobx-react";

@inject("ApplicationModel")
@observer
export default class CallbackLogic extends React.Component {
	componentDidMount() {
		this.initAutoOpen();
	}

	initAutoOpen() {
		this.timer = setTimeout(() => this.openCallback(), 20000);
		this.mouseLeaveSavedFunc = (e) => this.mouseLeaveHandler(e);
		this.mouseEnterSavedFunc = (e) => this.mouseEnterHandler(e);
		document.addEventListener("mouseleave", this.mouseLeaveSavedFunc);
		document.addEventListener("mouseenter", this.mouseEnterSavedFunc);
		this.props.ApplicationModel.fixedPanelModel.setOpenCallbackCB(() => this.openCallback());
	}

	timer = null;
	timer2 = null;

	mouseLeaveHandler(event) {
		if (event.clientY < 10 || event.screenY < 10 || event.offsetY < 10) {
			if (!this.timer2) {
				this.timer2 = setTimeout(() => this.openCallback(), 1000);
			}
		}
	}

	mouseEnterHandler(event) {
		if (this.timer2) {
			clearTimeout(this.timer2);
		}
	}

	openCallback() {
		if (!this.state.wasOpened) {
			let fixedPanelModel = this.props.ApplicationModel.fixedPanelModel;
			let modalModel = this.props.ApplicationModel.modalModel;
			fixedPanelModel.setOpenCallbackCB(null);
			clearTimeout(this.timer);
			clearTimeout(this.timer2);
			document.removeEventListener("mouseleave", this.mouseLeaveSavedFunc);
			document.removeEventListener("mouseenter", this.mouseEnterSavedFunc);
			if (!modalModel.isOpen) {
				this.setState({
					wasOpened: true,
				});
				fixedPanelModel.openCallback();
			} else {
				this.initAutoOpen();
			}
		}
	}

	constructor(props) {
		super(props);
		this.state = {
			wasOpened: true,
		};
	}

	render() {
		return this.props.children;
	}
}
